/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { registry } from '@/lib/registry';

// STATIC_REGISTRY_START

/* eslint-disable */
/**
 * Initialize the static component registry.
 * This function is auto-generated by the staticRegistry Vite plugin.
 * 
 * DO NOT EDIT THIS FUNCTION MANUALLY - it will be overwritten on next build.
 * 
 * Components registered: odyssey_base.contentCard, odyssey_base.exampleBanner, odyssey_base.grid, odyssey_base.hero, odyssey_base.heroCarousel, odyssey_base.insideSpace, odyssey_base.linkCard, odyssey_base.pdImage, odyssey_base.popularCategories, odyssey_base.popularCategory, odyssey_base.productCarousel, odyssey_base.productRecommendations, odyssey_base.productTile
 */
export function initializeRegistry(targetRegistry = registry): void {
    targetRegistry.registerImporter('odyssey_base.contentCard', () => import('../components/content-card/index'));
    targetRegistry.registerImporter('odyssey_base.exampleBanner', () => import('../components/page-designer/example-banner/index'));
    targetRegistry.registerImporter('odyssey_base.grid', () => import('../components/grid/index'));
    targetRegistry.registerImporter('odyssey_base.hero', () => import('../components/hero/index'));
    targetRegistry.registerImporter('odyssey_base.heroCarousel', () => import('../components/hero-carousel/index'), { fallback: 'fallback' });
    targetRegistry.registerImporter('odyssey_base.insideSpace', () => import('../components/page-designer/inside-space/index'));
    targetRegistry.registerImporter('odyssey_base.linkCard', () => import('../components/page-designer/link-card/index'));
    targetRegistry.registerImporter('odyssey_base.pdImage', () => import('../components/dynamic-image/index'));
    targetRegistry.registerImporter('odyssey_base.popularCategories', () => import('../components/home/popular-categories/index'), { loader: 'loader' });
    targetRegistry.registerImporter('odyssey_base.popularCategory', () => import('../components/home/popular-category/index'), { loader: 'loader' });
    targetRegistry.registerImporter('odyssey_base.productCarousel', () => import('../components/product-carousel/index'), { loader: 'loader', fallback: 'fallback' });
    targetRegistry.registerImporter('odyssey_base.productRecommendations', () => import('../components/product-recommendations/index'));
    targetRegistry.registerImporter('odyssey_base.productTile', () => import('../components/product-tile/index'));
}

// STATIC_REGISTRY_END
